import React from 'react';
import * as S from './CustomRadioButtonUI.styles';

type RadioBtnProps = {
  isActive        ?: boolean;
  isCheckMark     ?: boolean;
  borderColor     ?: string;
  backgroundColor ?: string;
}

const CustomRadioButton = ({isActive, isCheckMark = false, borderColor, backgroundColor}: RadioBtnProps) => {
  return (
    <S.RadioLabel>
      <S.RadioInput type="radio" checked={isActive} borderColor={borderColor}/>
      {(isCheckMark && (
        <S.Checkmark ></S.Checkmark>
      ) || (
        <S.Dot backgroundColor={backgroundColor}></S.Dot>
      ))}
    </S.RadioLabel>
  )
}

export default CustomRadioButton;  